<div class="dialog">
  <div class="dialog-top">
    <h2 class="dialog-title short-text"> {{local_data.title}} </h2>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="close-button"
      mat-dialog-close>
      <circle opacity="0.05" cx="20" cy="20" r="20" fill="#0080FF" />
      <path opacity="0.8"
        d="M20.9161 19.9999L24.8099 23.8939C25.0634 24.1472 25.0634 24.5567 24.8099 24.81C24.5567 25.0633 24.1471 25.0633 23.8939 24.81L19.9999 20.916L16.1061 24.81C15.8527 25.0633 15.4433 25.0633 15.1901 24.81C14.9366 24.5567 14.9366 24.1472 15.1901 23.8939L19.0839 19.9999L15.1901 16.1059C14.9366 15.8526 14.9366 15.4431 15.1901 15.1898C15.3163 15.0635 15.4822 15 15.6481 15C15.8139 15 15.9798 15.0635 16.1061 15.1898L19.9999 19.0838L23.8939 15.1898C24.0202 15.0635 24.1861 15 24.3519 15C24.5178 15 24.6836 15.0635 24.8099 15.1898C25.0634 15.4431 25.0634 15.8526 24.8099 16.1059L20.9161 19.9999Z"
        fill="#0080FF" />
    </svg>
  </div>

  <mat-dialog-content class="dialog-flex">
    <form [formGroup]="formGroup">

      <div class="dialog-box">
        <label class="mb-2 input-label mandatory"><span>*</span> {{variables?.name || 'Nombre'}}</label>
        <mat-form-field
          [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': nameInvalidInput, 'mat-form-field-invalid': nameInvalidInput}"
          class="form-field" appearance="outline">
          <mat-select formControlName="standardNameCtrl" (selectionChange)="onProfileNameChange($event.value)"
            placeholder="{{variables?.selectProfileName || 'Seleccione un nombre de perfil'}}">
            @for (name of profileNames; track name) {
            <mat-option [value]="name">
              {{name}}
            </mat-option>
            }
            <mat-option value="other">
              {{variables?.other || 'Otro'}}
            </mat-option>
          </mat-select>
          @if (nameInvalidInput) {
          <mat-hint class="error-hint">{{nameErrorMessage}}</mat-hint>
          }
        </mat-form-field>
      </div>


      @if (otherNameType) {
      <div class="dialog-box">
        <label class="mb-2 input-label mandatory"><span>*</span> {{variables?.name || 'Nombre'}}</label>
        <mat-form-field
          [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': nameInvalidInput, 'mat-form-field-invalid': nameInvalidInput}"
          class="form-field" appearance="outline">
          <input matInput formControlName="nameCtrl"
            placeholder="{{variables?.profileNamePlaceholder || 'Ej: Desarrollador España Junior'}}">
          @if (nameInvalidInput) {
          <mat-hint class="error-hint">{{nameErrorMessage}}</mat-hint>
          }
        </mat-form-field>
      </div>
      }


      <div class="dialog-box">
        <label class="mb-2 input-label">{{variables?.description || 'Descripción'}}</label>
        <mat-form-field class="form-field" appearance="outline">
          <textarea matInput formControlName="descriptionCtrl" cdkTextareaAutosize cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="3"
            placeholder="{{variables?.profileDescriptionPlaceholder || 'Ej: Becario, Junior, Senior...'}}"></textarea>
        </mat-form-field>
      </div>


      <div class="dialog-box">
        <label class="mb-2 input-label mandatory"><span>*</span> {{variables?.costPerHour || 'Coste (€/hora)'}}</label>
        <mat-form-field
          [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': costInvalidInput, 'mat-form-field-invalid': costInvalidInput}"
          class="form-field" appearance="outline">
          <input type="number" matInput formControlName="costCtrl" step="0.01" min="0" placeholder="0.00">
          <span matSuffix>€/h</span>
          @if (costInvalidInput) {
          <mat-hint class="error-hint">{{costErrorMessage}}</mat-hint>
          }
        </mat-form-field>
      </div>


      <div class="dialog-box">
        <label class="mb-2 input-label">{{variables?.costCenter || 'Centro de coste'}}</label>
        <mat-form-field class="form-field" appearance="outline">
          <mat-select formControlName="standardCenterCtrl" (selectionChange)="onCenterChange($event.value)"
            placeholder="{{variables?.selectCostCenter || 'Seleccione un centro de coste'}}">
            @for (center of centers; track center) {
            <mat-option [value]="center">
              {{center}}
            </mat-option>
            }
            <mat-option value="other">
              {{variables?.other || 'Otro'}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      @if (otherCenterType) {
      <div class="dialog-box">
        <label class="mb-2 input-label">{{variables?.costCenter || 'Centro de coste'}} ({{variables?.other ||
          'Otro'}})</label>
        <mat-form-field class="form-field" appearance="outline">
          <input matInput formControlName="centerCtrl"
            placeholder="{{variables?.centerPlaceholder || 'Ej: Madrid, Barcelona...'}}">
        </mat-form-field>
      </div>
      }


    </form>
    <div>
      <mat-dialog-actions class="button-group">
        <app-button typeBtn="secondary" message="{{variables?.cancel || 'Cancelar'}}" mat-dialog-close></app-button>
        <app-button typeBtn="primary" (click)="doAction()" message="{{variables?.save || 'Guardar'}}"></app-button>
      </mat-dialog-actions>
    </div>
  </mat-dialog-content>

</div>